import { Type } from 'class-transformer';

export class UserActivity {
  readonly portalType = 'H';
  host: string; // Will be set by the service that uses this class

  userId: string;
  clientIP: string;
  serverName: string;
  alias: string;
  route: string;
  activity: string;
  @Type(() => Date)
  dateTimeStamp: Date;
  communityId: number;
  additionalInfo: string;
  screenSize: string;
  browser: string;
  browserVersion: string;
  operatingSystem: string;
  osVersion: string;
  device: string;
  userAgent: string;

  constructor() {}
}
